import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import { Router, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import axios from 'axios';

import './images/favicon.ico';

// Project imports
import routes from './routes';
import configureStore from './store';
import { getEnvironmentUrls, login } from './actions/urlTypes';
import { ServerErrorComponent } from './components/common/ServerErrorComponent';
import { logOut } from './actions/loginActions';
import { IS_LOGOUT } from './actions/actionTypes';

// index.scss
require('applicationStyles');

// Load Foundation
$(document).foundation();


const store = configureStore();
axios.interceptors.response.use( (response) => {
  // Any status code that lie within the range of 2xx cause this function to trigger
  return response;
},  (error) => {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if(error && error.response.data && error.response.data.errorCode === "IP_CHANGED") {
    store.dispatch({ type: IS_LOGOUT, isLogout: true });
  }
  return Promise.reject(error);
});

const appRoot = document.getElementById('app');
const renderServerError = () => render(<ServerErrorComponent />, appRoot);

getEnvironmentUrls().then(response => {
  if (response) {
    login(store).then(response => {
      if (response) {
        render(<Provider store={store}>
          <Router history={browserHistory} routes={routes} />
        </Provider>,
          appRoot,
        );
      } else {
        // console.log('error');
        logOut();
      }
    });
  } else {
    renderServerError();
  }
})
.catch(err => {
  console.warn(err);
  renderServerError();
});
